var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import widgetsDictionary from "../widgetsDictionary";
import { Dropdown, Menu, MenuButton, MenuItem, Option, Select } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { slotDirection } from "@/utils/funcs";
import { SlotDirection } from "@/utils/types/layout";
import { faBuilding, faDollarSign, faFile, faPhone, faPlus, faTasks, faUser, faUserTie, } from "@fortawesome/pro-regular-svg-icons";
import { useAppSelector } from "@/hooks/store";
export default function WidgetCreate(_a) {
    var _b;
    var widget = _a.widget;
    var hasDefault = useAppSelector(function (state) { return state.theme; }).hasDefault;
    var t = useTranslation(["common", "Administration", "Emails"]).t;
    var quickCreateLinks = [
        {
            label: "".concat(t("app.LBL_QUICK_ACCOUNT", { ns: "common" })),
            module: "Accounts",
            icon: faBuilding,
        },
        {
            label: "".concat(t("app.LBL_QUICK_CONTACT", { ns: "common" })),
            module: "Contacts",
            icon: faUser,
        },
        {
            label: "".concat(t("app.LBL_QUICK_OPPORTUNITY", { ns: "common" })),
            module: "Opportunities",
            icon: faDollarSign,
        },
        {
            label: "".concat(t("app.LBL_QUICK_LEAD", { ns: "common" })),
            module: "Leads",
            icon: faUserTie,
        },
        {
            label: "".concat(t("app.LBL_QUICK_DOCUMENT", { ns: "common" })),
            module: "Documents",
            icon: faFile,
        },
        {
            label: "".concat(t("app.LBL_QUICK_CALL", { ns: "common" })),
            module: "Calls",
            icon: faPhone,
        },
        {
            label: "".concat(t("app.LBL_QUICK_TASK", { ns: "common" })),
            module: "Tasks",
            icon: faTasks,
        },
    ];
    var modeAffichage = ((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.affichage) || "none";
    var centerHeaderFooter = typeof widget.slot === "string" &&
        (widget.slot.includes("HEADER_CENTER") ||
            widget.slot.includes("FOOTER_CENTER"));
    var direction = widget.slot
        ? slotDirection(widget.slot)
        : SlotDirection.VERTICAL;
    return (_jsx(_Fragment, { children: direction === "VERTICAL" ? (modeAffichage === "direct" || modeAffichage === "none" ? (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "m-3" }, { children: [_jsx("div", { children: _jsx("h2", __assign({ className: "uppercase font-bold justify-center items-center flex" }, { children: t("LBL_QUICK_CREATE", { ns: "Emails" }) })) }), _jsx("ul", __assign({ className: "rounded-md p-1 mt-2 uppercase " }, { children: quickCreateLinks.map(function (_a) {
                            var label = _a.label, module = _a.module, icon = _a.icon;
                            return (_jsx("li", __assign({ className: "m-1 min-h-6 py-2 cursor-pointer hover:bg-[#eef1f7] hover:rounded" }, { children: _jsxs("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(module, "/EditView"), className: "pl-2 mr-1" }, { children: [_jsx(FontAwesomeIcon, { icon: icon, size: "sm", className: "mr-4" }), _jsx("span", { children: label })] })) }), label));
                        }) }))] })) })) : (_jsx(Dropdown, { children: _jsxs("div", __assign({ style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                } }, { children: [_jsx(MenuButton, __assign({ variant: "plain", sx: {
                            width: "50px",
                            minWidth: "unset",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:hover": {
                                backgroundColor: "none",
                            },
                        } }, { children: _jsx(FontAwesomeIcon, { icon: faPlus, className: "text-black", size: "xl" }) })), _jsx(Menu, __assign({ className: "min-w-[200px]", sx: {
                            backgroundColor: hasDefault
                                ? "var(--colors-widget)"
                                : "transparent",
                            boxShadow: "none",
                            maxHeight: "none",
                            overflowY: "hidden",
                        } }, { children: quickCreateLinks.map(function (_a) {
                            var label = _a.label, module = _a.module, icon = _a.icon;
                            return (_jsxs(MenuItem, __assign({ className: "hover:bg-[#eef1f7] hover:rounded uppercase", component: Link, to: "/modules/".concat(module, "/EditView"), sx: {
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                } }, { children: [_jsx("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(module, "/EditView") }, { children: _jsx(FontAwesomeIcon, { icon: icon, size: "sm" }) })), _jsx("span", __assign({ className: "flex flex-row justify-end" }, { children: label }))] }), module));
                        }) }))] })) }))) : (_jsx("div", __assign({ style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
            } }, { children: _jsxs(Dropdown, { children: [_jsx(MenuButton, __assign({ variant: "plain", sx: {
                            width: "50px",
                            minWidth: "unset",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:hover": {
                                backgroundColor: "transparent",
                            },
                        } }, { children: _jsx(FontAwesomeIcon, { icon: faPlus, className: "text-black", size: "xl" }) })), _jsx(Menu, __assign({ placement: centerHeaderFooter ? undefined : "bottom-start", className: "min-w-[200px]", sx: {
                            backgroundColor: hasDefault
                                ? "var(--colors-widget)"
                                : "transparent",
                            boxShadow: "none",
                            maxHeight: "none",
                            overflowY: "hidden",
                        } }, { children: quickCreateLinks.map(function (_a) {
                            var label = _a.label, module = _a.module, icon = _a.icon;
                            return (_jsxs(MenuItem, __assign({ className: "hover:bg-[#eef1f7] hover:rounded px-2 py-1 uppercase", component: Link, to: "/modules/".concat(module, "/EditView"), sx: {
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                } }, { children: [_jsx("a", __assign({ href: "/modules/".concat(module, "/EditView") }, { children: _jsx(FontAwesomeIcon, { icon: icon, size: "sm", className: "mr-2" }) })), _jsx("span", { children: label })] }), module));
                        }) }))] }) }))) }));
}
function WidgetCreateSettings(_a) {
    var _b;
    var widget = _a.widget, onChange = _a.onChange;
    var direction = JSON.parse(localStorage.getItem("direction") || "");
    var t = useTranslation(["common"]).t;
    return (_jsx(_Fragment, { children: direction === "VERTICAL" ? (_jsxs(_Fragment, { children: [_jsx("label", { children: t("app.LBL_DISPLAY_MODE") }), _jsxs(Select, __assign({ value: ((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.affichage) || "", onChange: function (event, v) {
                        onChange &&
                            onChange(widget, __assign(__assign({}, widget), { payload: __assign(__assign({}, widget.payload), { affichage: v }) }));
                    } }, { children: [_jsx(Option, __assign({ value: "button" }, { children: t("app.LBL_DROP_DOWN_MENU", { ns: "common" }) }), "button"), _jsx(Option, __assign({ value: "direct" }, { children: t("app.LBL_DIRECT_DISPLAY", { ns: "common" }) }), "direct")] }))] })) : (_jsx(_Fragment, {})) }));
}
widgetsDictionary.register("widget/create", {
    name: "Widget for quick create",
    display: WidgetCreate,
    selectable: true,
    settings: WidgetCreateSettings,
});
